import { BlackHatTypes } from '@mono/proto-clients';
export function scenarioDrafts(scenarios) {
    return scenarios.map((s)=>({
            id: s.id,
            label: s.label,
            role: s.role,
            periodMonths: s.periodMonths ? String(s.periodMonths) : '',
            lines: s.lines.map((l)=>({
                    id: l.id,
                    label: l.label,
                    quantity: l.quantity,
                    unit: l.unit,
                    rate: l.rate && {
                        source: l.rate.source,
                        observationId: l.rate.observationId,
                        observationVersion: l.rate.observationVersion,
                        amount: l.rate.source === 'manual' ? l.rate.amount : '',
                        unit: l.rate.source === 'manual' ? l.rate.unit : 0,
                        provenance: l.rate.source === 'manual' ? l.rate.provenance : ''
                    }
                })),
            override: s.override && {
                valueCents: s.override.valueCents.toString(),
                reason: s.override.reason
            }
        }));
}
// Empty means "not set" (0). Otherwise a whole number of months, 0-600.
export function periodMonthsError(value) {
    const v = value.trim();
    if (!v) return '';
    return /^\d+$/.test(v) && Number(v) <= 600 ? '' : 'Enter a whole number of months from 0 to 600.';
}
export function scenarioInputs(drafts) {
    return drafts.map((s)=>{
        if (s.override && (!/^\d+$/.test(s.override.valueCents) || BigInt(s.override.valueCents) > BigInt('9223372036854775807') || !s.override.reason.trim())) {
            throw new Error('Override requires nonnegative int64 cents and a reason.');
        }
        if (periodMonthsError(s.periodMonths)) {
            throw new Error(`Scenario "${s.label}": ${periodMonthsError(s.periodMonths)}`);
        }
        return new BlackHatTypes.BlackHatScenarioInput({
            ...s,
            periodMonths: Number(s.periodMonths.trim() || 0),
            lines: s.lines.map((l)=>({
                    ...l,
                    rate: l.rate?.source === 'observation' ? {
                        source: 'observation',
                        observationId: l.rate.observationId,
                        observationVersion: l.rate.observationVersion
                    } : l.rate
                })),
            override: s.override && {
                valueCents: BigInt(s.override.valueCents),
                reason: s.override.reason
            }
        });
    });
}
// The catalog exposes correction links, not an observation-version field.
// Missing ancestry must never guess a version (LCAT versions are independent).
export function observationVersion(id, rows) {
    const seen = new Set();
    let version = 0;
    let next = id;
    while(next){
        if (seen.has(next)) return undefined;
        seen.add(next);
        const row = rows.find((r)=>r.id === next);
        if (!row) return undefined;
        version += 1;
        next = row.correctsId;
    }
    return version || undefined;
}
// Preserve every cent, including values above Number.MAX_SAFE_INTEGER.
// The shared number-only money formatter cannot represent these values.
export function scenarioMoney(cents) {
    return `$${(cents / BigInt(100)).toLocaleString('en-US')}.${(cents % BigInt(100)).toString().padStart(2, '0')}`;
}
